import React from "react";
import { Segment } from "semantic-ui-react";

import AppSettings from "../../../config";
import { useParams } from "react-router-dom";
import TopNavigation from "../TopNavigation";
import { useIframeSessionListener } from "../../../hooks/useIframeSessionListener";
import { Products } from "../../../constants/products";
import { CeTopNavigation } from "../../code/CodeTopNavigation";
import { ReportObjectTypes } from "../../../constants/ReportObjectTypes";

export interface ReportViewProps {
  reportType: string;
}

export const CreateReport = (props: ReportViewProps) => {
  const params = useParams<{ site: string }>();

  //Grab cleaned queryString
  const queryString = window.location.search.replace("?", "");

  //if queryString exists, we want to frame the page with the last viewed report on it, otherwise we use a new report entirely
  const sourceURL = queryString.includes("last")
    ? `${AppSettings.GOGOV_WEB_URL}/${params.site}/reports.php`
    : `${AppSettings.GOGOV_WEB_URL}/${params.site}/reports.php?cmd=new&objectType=${
        props.reportType === Products.CRM ? ReportObjectTypes.REPORTS_CRM : ReportObjectTypes.REPORTS_CE
      }`;

  useIframeSessionListener();
  return (
    <>
      {props.reportType === Products.CRM && (
        <TopNavigation
          tabs={[
            { to: "/crm/list", label: "Requests", activeWhenURLIncludes: "/crm/list" },
            { to: "/crm/reports", label: "Reports", activeWhenURLIncludes: "/crm/reports" },
          ]}
        />
      )}
      {props.reportType === Products.CE && <CeTopNavigation />}
      <Segment className='tw-mx-4 tw-my-[8px] tw-p-2'>
        <iframe title='exchange' src={sourceURL} style={{ border: 0, width: "100%", height: "calc(100vh - 100px)" }} />
      </Segment>
    </>
  );
};
